import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Waypoint from 'react-waypoint';


// The PostsList iterates over all of the players and creates
// a link to their profile page.
class PostListItem extends Component {
  state = {
    inViewPortClass: '',
    clickedClass: '',
  }

  handleEnter() {
    this.setState({ inViewPortClass: 'inView' });
  }
  handleLeave() {
    this.setState({ inViewPortClass: '' });
  }

  handleClick() {
    this.setState({ clickedClass: 'active' });
  }

  render() {
    const {
      post, postType, postSection, projectIndex,
    } = this.props;

    function twoDigitNumber(n) { // https://stackoverflow.com/questions/8043026/javascript-format-number-to-have-2-digit
      return n > 9 ? `${n}` : `0${n}`;
    }
    return (
      <Waypoint onEnter={() => this.handleEnter()} onLeave={() => this.handleLeave()}>
        <li key={post.slug} className={`post-list__item post-list__item--${post.slug} ${this.state.inViewPortClass}`}>
          <Link
            onClick={() => this.handleClick()}
            // onTouchEnd={() => this.handleClick()}
            data-visited={localStorage.getItem(`visited-/play/${post.slug}/`)}
            className={`post-title post-list__link ${this.state.clickedClass} ${this.props.location.pathname === `/${postSection}/${post.slug}/` ? 'active-link' : ''}`}
            to={`/${postSection}/${post.slug}/`}
          >
            { /* If-Else in JSX https://react-cn.github.io/react/tips/if-else-in-JSX.html */
              (() => {
                if (postType === 'Projects') {
                  return (
                    <span className="post-title__number post-list__number">{twoDigitNumber(projectIndex + 1)}</span>
                  );
                }
              })()
            }
            <span className="post-title__words" style={postType === 'BlogPosts' && post.svg_title === 'true' ? { fontSize: '1.3em' } : null}>
              {
                post.title.map((palabra) => {
                  if (post.svg_title === 'true') {
                    return (
                      <span key={palabra.id}>
                        <span className={`post-title__word post-title__${palabra.id}`}>
                          <svg role="img" aria-hidden="true" className="post-title__svg" style={palabra.width ? { width: `${palabra.width}em` } : null}>
                            <use xlinkHref={`/img/${postType === 'BlogPosts' ? post.slug : 'project-titles'}.svg?v1#${palabra.id}`} />
                          </svg>
                          <span className="visuallyhidden">{palabra.word}</span>
                        </span>{' '}
                      </span>
                    );
                  }
                  return (
                    <span key={palabra.id} style={{ fontFamily: post.font_family, fontWeight: post.font_weight }}>
                      {`${palabra.word} `}
                    </span>
                  );
                })
              }
            </span>
          </Link>
        </li>
      </Waypoint>
    );
  }
}

PostListItem.propTypes = {
  post: PropTypes.shape({
  }).isRequired,
  postType: PropTypes.string.isRequired,
  postSection: PropTypes.string.isRequired,
  projectIndex: PropTypes.number.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(PostListItem);



// WEBPACK FOOTER //
// ./src/components/PostListItem.js